import React from "react";
import "components/Project/ActiveProject/Step_2/Challenge2Details.css";
import "react-datepicker/dist/react-datepicker.css";
import TextTheme from "components/General/Text/TextTheme";

import "containers/ProjectCommon.css";
import AxiosConfig from "axiosConfig";
import ProgressStepper from "components/Project/ProgressStepper";
import ProjectBanner from "components/Project/ProjectBanner";
import ProjectOldInfo from "components/Project/Details/ProjectOldInfo";
import DatePicker from "react-datepicker";
import TwoButtonLayout from "components/General/Form/CustomButton/TwoButtonLayout";
/**
 * @summary: Creates the UI of the challenge 2 page
 * @description: Creates the fields and styling for the challenge 2 selection of task page
 * @class: ProjectContent
 * @extends: React.component
 * @see: {Challenge2Details.css}
 * @param: projectName, projectBanner, projectBadge, projectJoinDate, projectChallengeStatus, selectedOption
 * @returns: {ProjectContent}
 */

class ProjectContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectSlug: this.props.slug,
      projectName: "",
      projectBanner: "",
      projectBadge: "",
      projectJoinDate: "",
      projectChallengeStatus: "",
      selectedOption: "",
      spread: "",
      skill: "",
      habit: "",
      volunteer: "",
      give: "",
      fundraise: "",
      voice: "",
    };
  }

  componentDidMount() {
    const projectSlug = this.props.slug;
    AxiosConfig.get(`/impactprojects/project/${projectSlug}/`)
      .then((res) => {
        this.setState({
          projectBanner: res.data.banner,
          spread: res.data.spread,
          skill: res.data.skill,
          habit: res.data.habit,
          volunteer: res.data.volunteer,
          give: res.data.give,
          fundraise: res.data.fundraise,
          voice: res.data.voice,
        });
      })
      .catch();
  }

  render() {
    return (
      <div className="header_main">
        <div className="page_info_hr_content_main">
          <div className="header_step_banner_main">
            <div className="banner_main">
              <div className="banner_main_content">
                <ProjectBanner image={this.state.projectBanner} />
              </div>
            </div>

            <div className="stepper_main">
              <div className="stepper_main_content">
                <ProgressStepper currentStep="1" />
              </div>
            </div>
          </div>
          <ProjectOldInfo project={this.state.projectSlug} />
        </div>

        <div className="page_main">
          <div className="page_info_vr_content_main">
            <ProjectOldInfo vertical={true} project={this.state.projectSlug} />
          </div>
          <form onSubmit={this.handleFormSubmit}>
            <div className="page_details_main">
              <div className="project-banner">
                <ProjectBanner image={this.state.projectBanner} />
              </div>
              <div className="stepper_main_content">
                <ProgressStepper currentStep="2" />
              </div>
              <div className="share-story page_details_content_main">
                <TextTheme
                  message="Challenge 2: Ideation"
                  className="text_large text_dark_blue"
                />
                <br />
                <TextTheme
                  message="SET YOUR GOAL"
                  className="text_medium text_black text_semi_bold"
                />
                <br />
                <TextTheme
                  message="1. How can I make a difference? Explore the following impact adventures and set your project goal."
                  className="text_medium text_black"
                />
                <ul className="OptionList">
                  <li>
                    <input
                      name="Option"
                      type="radio"
                      value="1"
                      checked={this.state.checked}
                      onClick={this.props.handleChecked}
                    />
                    <label htmlFor="Option">
                      {" "}
                      <TextTheme
                        message={"SPREAD THE WORD: "}
                        className="text_small text_black"
                      />
                      <div
                        dangerouslySetInnerHTML={{
                          __html: this.state.spread,
                        }}
                      ></div>
                    </label>
                  </li>
                  <li>
                    <input
                      name="Option"
                      type="radio"
                      value="2"
                      checked={this.state.checked}
                      onClick={this.props.handleChecked}
                    />
                    <label htmlFor="Option">
                      {" "}
                      <TextTheme
                        message={"LEARN NEW SKILL: "}
                        className="text_small text_black"
                      />
                      <div
                        dangerouslySetInnerHTML={{
                          __html: this.state.skill,
                        }}
                      ></div>
                    </label>
                  </li>
                  <li>
                    <input
                      name="Option"
                      type="radio"
                      value="3"
                      checked={this.state.checked}
                      onClick={this.props.handleChecked}
                    />
                    <label htmlFor="Option">
                      {" "}
                      <TextTheme
                        message={"DEVELOP NEW HABIT: "}
                        className="text_small text_black"
                      />
                      <div
                        dangerouslySetInnerHTML={{
                          __html: this.state.habit,
                        }}
                      ></div>
                    </label>
                  </li>
                  <li>
                    <input
                      name="Option"
                      type="radio"
                      value="4"
                      checked={this.state.checked}
                      onClick={this.props.handleChecked}
                    />
                    <label htmlFor="Option">
                      {" "}
                      <TextTheme
                        message={"VOLUNTEER: "}
                        className="text_small text_black"
                      />
                      <div
                        dangerouslySetInnerHTML={{
                          __html: this.state.volunteer,
                        }}
                      ></div>
                    </label>
                  </li>
                  <li>
                    <input
                      name="Option"
                      type="radio"
                      value="5"
                      checked={this.state.checked}
                      onClick={this.props.handleChecked}
                    />
                    <label htmlFor="Option">
                      <TextTheme
                        message={"DONATE: "}
                        className="text_small text_black"
                      />
                      <div
                        dangerouslySetInnerHTML={{
                          __html: this.state.give,
                        }}
                      ></div>
                    </label>
                  </li>
                  <li>
                    <input
                      name="Option"
                      type="radio"
                      value="6"
                      checked={this.state.checked}
                      onClick={this.props.handleChecked}
                    />
                    <label htmlFor="Option">
                      {" "}
                      <TextTheme
                        message={"FUNDRAISE: "}
                        className="text_small text_black"
                      />
                      <div
                        dangerouslySetInnerHTML={{
                          __html: this.state.fundraise,
                        }}
                      ></div>
                    </label>
                  </li>
                  <li>
                    <input
                      name="Option"
                      type="radio"
                      value="7"
                      checked={this.state.checked}
                      onClick={this.props.handleChecked}
                    />
                    <label htmlFor="Option">
                      {" "}
                      <TextTheme
                        message={"RAISE YOUR VOICE: "}
                        className="text_small text_black"
                      />
                      <div
                        dangerouslySetInnerHTML={{
                          __html: this.state.voice,
                        }}
                      ></div>
                    </label>
                  </li>
                </ul>
                <br />
                <TextTheme
                  message="2. Set a target date to complete your goal:"
                  className="text_medium text_black"
                />
                <div className="DatePick">
                  <DatePicker
                    selected={this.props.goalDate}
                    onChange={this.props.handleDateChange}
                  />
                </div>
                <TwoButtonLayout
                  button1Text="SAVE AND QUIT"
                  button2Text="NEXT"
                  button1Click={() => window.location.assign("/")}
                  button2Click={this.props.onSubmit}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default ProjectContent;
